<template>
  <div>
    <v-row class="d-flex ma-3 mb-0">
      <v-col cols="3">
        <period-filter></period-filter>
      </v-col>
      <v-col cols="3">
        <date-filter
          store="marmiton"
          storeGetter="getMarmitonDates"
          storeUpdater="updateMarmitonDates"
          periodType="past-only"
          :range="7"
        ></date-filter>
      </v-col>
      <v-col cols="6"> </v-col>
    </v-row>
    <v-row class="d-flex ma-3 mt-0">
      <v-col cols="6">
        <ingredient-filter
          label="Ingrédients"
          storeGetter="getMarmitonIngredientsToInclude"
          storeUpdater="updateMarmitonIngredientsToInclude"
        ></ingredient-filter>
      </v-col>
      <v-col cols="6">
        <ingredient-filter
          label="Ingrédients à exclure"
          storeGetter="getMarmitonIngredientsToExclude"
          storeUpdater="updateMarmitonIngredientsToExclude"
          :toExclude="true"
        ></ingredient-filter>
      </v-col>
    </v-row>
    <v-row class="d-flex ma-3 mt-0">
      <v-col cols="3">
        <dish-filter />
      </v-col>
      <v-col cols="3">
        <cost-filter />
      </v-col>
      <v-col cols="3">
        <duration-filter />
      </v-col>
      <v-col cols="3"> </v-col>
    </v-row>
    <v-row class="d-flex ma-3 mt-0">
      <v-col cols="3">
        <rating-filter />
      </v-col>
      <v-col cols="3">
        <rates-filter />
      </v-col>
      <v-col cols="6" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";
import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import CostFilter from "@/components/regie/common/filters/CostFilter";
import DateFilter from "@/components/common/filters/DateFilter";
import DishFilter from "@/components/regie/common/filters/DishFilter";
import DurationFilter from "@/components/regie/common/filters/DurationFilter";
import IngredientFilter from "@/components/regie/common/filters/IngredientFilter";
import PeriodFilter from "@/components/regie/marmiton/filters/PeriodFilter";
import RatesFilter from "@/components/regie/common/filters/RatesFilter";
import RatingFilter from "@/components/regie/common/filters/RatingFilter";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    CostFilter,
    DateFilter,
    DishFilter,
    DurationFilter,
    IngredientFilter,
    PeriodFilter,
    RatesFilter,
    RatingFilter,
  },
  data() {
    return {};
  },
  setup() {
    const { isLoading } = useAxios();

    return {
      isLoading,
    };
  },
};
</script>

<style></style>
